<template>
  <div class="statistic-widget-summary">
    <div class="row">
      <div v-for="(item, index) in data.data" :key="index" :class="`col-sm-12 col-md-6 col-lg-4 statistic-widget-${index}`">
        <div class="card widget-summary-item">
          <h5 :class="`mb-2 title text-${data?.labels?.[index]?.color}`">{{ data?.labels?.[index]?.label || '' }}</h5>
          <div class="summary-items">
            <div class="summary-item quantity d-flex justify-content-between align-items-center">
              <label class="m-0">Order Quantity: </label>
              <span class="fsize-2 text-success font-weight-bolder">{{ item?.quantity || 0 }}</span>
            </div>
            <div class="summary-item in-progress d-flex justify-content-between align-items-center">
              <label class="m-0">In progress: </label>
              <span class="fsize-2 text-warning font-weight-bolder">{{ item?.['in-progress'] || 0 }}</span>
            </div>
            <div class="summary-item purchased d-flex justify-content-between align-items-center">
              <label class="m-0">Purchased: </label>
              <span class="fsize-2 text-info font-weight-bolder">{{ item?.purchased || 0 }}</span>
            </div>
            <div class="summary-item canceled d-flex justify-content-between align-items-center">
              <label class="m-0">Canceled: </label>
              <span class="fsize-2 text-danger font-weight-bolder">{{ item?.canceled || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    data() {
      return this.config?.data
    }
  },
  methods: {},
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.grid-container {
  .grid-item-summary {
    background: transparent !important;
    padding: 0 !important;
  }
}
.statistic-widget-summary {
  > .row {
    margin-bottom: -15px;
    > div {
      padding: 0 10px 20px 10px;
      .card {
        padding: 15px;
      }
    }
  }
  .widget-summary-item {
    container-type: inline-size;
    width: 100%;
  }
  .summary-items {
    display: flex;
    flex-wrap: wrap;
    gap: 0 30px;
    .summary-item {
      width: 100%;
    }
  }
  @container (min-width: 350px) {
    .summary-items {
      .summary-item {
        width: calc(50% - 15px);
      }
    }
  }
}
</style>
